/**
 * The door the action's settings show the standard layout with (D37): two slides, one
 * question with three answers and a prize, every picture a stand-in. Made up, nobody's
 * content; it only gives the layout something to arrange.
 */
const picture = (id, alt) => ({
    asset_id: id,
    alt_text: alt,
    kind: "image",
    needs_no_captions: false,
});
export const SAMPLE_DOOR = {
    field_position: 1,
    slides: [
        {
            title: "Neu für Ihre Praxis",
            body: "Hier stellt der Sponsor vor, worum es an diesem Tag geht: ein Produkt, eine Methode oder ein Angebot.",
            media: picture("beispiel-folie-1", "Beispielbild der ersten Folie"),
            button: { label: "Weiter", action: "next" },
        },
        {
            title: "Gut zu wissen",
            body: "Eine zweite Folie vertieft das Thema. Auf ihr steht auch die Antwort auf die Frage.",
            media: picture("beispiel-folie-2", "Beispielbild der zweiten Folie"),
            button: null,
        },
    ],
    quiz: {
        intro: "Eine Frage zum Inhalt der Folien.",
        success_text: "Richtig. Jetzt fehlen nur noch Ihre Angaben.",
        failure_text: "Die Antwort steht auf den Folien.",
        questions: [
            {
                question_id: "beispiel-frage",
                question_text: "Worum geht es an diesem Tag?",
                answer_options: { a: "Ein Produkt", b: "Ein Rezept", c: "Ein Reisebericht" },
                correct_option_key: "a",
                image: picture("beispiel-frage", "Beispielbild der Frage"),
                is_archived: false,
            },
        ],
    },
    prize_image: picture("beispiel-gewinn", "Beispielbild des Gewinns"),
    prize_description: "Hier steht der Gewinn des Tages.",
    prize_quantity: 1,
    prize_digital: false,
};
//# sourceMappingURL=sample.js.map